<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="close" max-width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">Carga múltiple de cheques</span>
        </v-card-title>

        <v-card-text>
          <div class="row">
            <div class="col-md-3">
              <DatePickerEsp
                :initToday="true"
                label="Fecha de emision"
                :date="header.emission_date"
                :isRequired="true"
                name="header_emission_date"
                @setDate="
                  (date) => {
                    header.emission_date = date;
                  }
                "
              />
            </div>
            <div class="col-md-3">
              <v-text-field v-if="thirdParty" autocomplete="off" label="Emisor*" v-model="header.emitter_name" />
              <v-text-field v-else label="Emisor" :value="header.emitter != null ? header.emitter.name : ''" disabled />
            </div>
            <div class="col-md-3">
              <v-text-field label="Cuenta de cheques" :value="header.money_account != null ? header.money_account.name : ''" disabled />
            </div>
            <div class="col-md-3">
              <v-combobox v-if="thirdParty" v-model="header.bank" item-text="name" item-value="id" :items="banks" label="Banco*" autocomplete="off"></v-combobox>
              <v-text-field v-else label="Banco" :value="header.bank != null ? header.bank.name : ''" disabled />
            </div>
          </div>

          <v-divider class="mb-4"></v-divider>

          <div class="row">
            <div class="col-md-3">
              <v-text-field autocomplete="off" label="Nro de cheque*" v-model="newRow.number" />
            </div>
            <div class="col-md-3">
              <DatePickerEsp label="Fecha de pago" :date="newRow.payment_date" name="row_payment_date" @setDate="(date) => (newRow.payment_date = date)" />
            </div>
            <div class="col-md-3">
              <v-text-field autocomplete="off" label="Importe*" type="number" v-model="newRow.amount" />
            </div>
            <div class="col-md-3">
              <v-text-field autocomplete="off" label="Observaciones" v-model="newRow.observations" />
            </div>
          </div>

          <v-row class="mt-0">
            <v-col md="12">
              <v-btn small color="blue-grey" class="text-white" @click="addCheque()">
                <v-icon big color="green"> add </v-icon>
                <span>Agregar cheque</span>
              </v-btn>
            </v-col>
            <v-col md="12">
              <v-data-table class="pb-4" :headers="headers" :items="cheques" style="border: solid 1px #1c1c1c" :hide-default-footer="true" :items-per-page="100" height="300" fixed-header>
                <template v-slot:item="props">
                  <tr>
                    <td>{{ props.item.number }}</td>
                    <td>{{ props.item.payment_date }}</td>
                    <td>{{ formatUtils.formatPrice(props.item.amount) }}</td>
                    <td>{{ props.item.observations }}</td>
                    <td class="text-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="red" @click="removeCheque(props.item)"> indeterminate_check_box </v-icon>
                        </template>
                        <span>Remover</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
            <v-col md="12" v-if="cheques.length > 0">
              <v-chip class="float-right" outlined color="primary">Total: {{ formatUtils.formatPrice(totalCheques) }}</v-chip>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="close">Cerrar</v-btn>
          <v-btn color="success" text @click="confirm">{{ confirmText }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { formatUtils } from "@/libs/utils/formatUtils";
import DatePickerEsp from "@/components/DatePickerEsp.vue";

export default {
  components: { DatePickerEsp },
  props: {
    dialog: Boolean,
    defaultMoneyAccount: {
      type: Object,
      default: null,
    },
    //Cheques de terceros (Cobros): Emisor texto libre y Banco seleccionable
    thirdParty: {
      type: Boolean,
      default: false,
    },
    defaultEmitterName: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "Agregar cheques al pago",
    },
  },
  data() {
    return {
      formatUtils: formatUtils,
      banks: [],
      headers: [{ text: "Número" }, { text: "Fecha de pago" }, { text: "Importe" }, { text: "Observaciones" }, { text: "", value: "", sortable: false, class: "bg-grey" }],
      header: {
        emission_date: null,
        emitter: null,
        emitter_name: "",
        money_account: null,
        bank: null,
      },
      newRow: {
        number: "",
        payment_date: null,
        amount: "",
        observations: null,
      },
      cheques: [],
    };
  },
  computed: {
    totalCheques() {
      return this.cheques.reduce((total, c) => total + parseFloat(c.amount || 0), 0);
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.header = {
          emission_date: this.todayDate(),
          emitter: this.thirdParty || this.defaultMoneyAccount == null ? null : this.defaultMoneyAccount.emitter,
          emitter_name: this.thirdParty ? this.defaultEmitterName || "" : "",
          money_account: this.defaultMoneyAccount,
          bank: this.thirdParty ? null : this.getBank(),
        };
        this.cheques = [];
        this.newRow = { number: "", payment_date: null, amount: "", observations: null };
      }
    },
  },
  mounted() {
    if (this.thirdParty) this.loadBanks();
  },
  methods: {
    loadBanks() {
      generalService.setSection(Constant.SECTION_BANKS);
      generalService
        .filter({ has_bank: true })
        .then((response) => {
          this.banks = response.result;
        })
        .catch((e) => {
          console.log("banks.filter error", e);
        });
    },
    validateHeader() {
      if (!this.header.emission_date) {
        this.$toast.error("Debe completar la fecha de emisión", "Error");
        return false;
      }
      if (this.thirdParty) {
        if (!this.header.emitter_name || String(this.header.emitter_name).trim() === "") {
          this.$toast.error("Debe completar el emisor", "Error");
          return false;
        }
        if (this.header.bank == null || !this.header.bank.id) {
          this.$toast.error("Debe seleccionar un banco", "Error");
          return false;
        }
        if (this.header.money_account == null) {
          this.$toast.error("No se encontró la cuenta Cheques en Cartera del emisor", "Error");
          return false;
        }
        if (this.header.money_account.emitter == null) {
          this.$toast.error("La cuenta de cheques no tiene una empresa receptora asociada", "Error");
          return false;
        }
      }
      return true;
    },
    todayDate() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
    },
    getBank() {
      if (this.defaultMoneyAccount != null && this.defaultMoneyAccount.parent_money_account != null && this.defaultMoneyAccount.parent_money_account.bank != null) {
        return this.defaultMoneyAccount.parent_money_account.bank;
      }
      return null;
    },
    nextNumber(current) {
      const str = String(current);
      if (!/^\d+$/.test(str)) return "";
      const next = (parseInt(str, 10) + 1).toString();
      return next.padStart(str.length, "0");
    },
    addCheque() {
      if (!this.validateHeader()) return;
      if (!this.newRow.number || String(this.newRow.number).trim() === "") {
        this.$toast.error("Debe completar el número de cheque", "Error");
        return;
      }
      if (this.cheques.some((c) => String(c.number) === String(this.newRow.number))) {
        this.$toast.error("Ya se agregó un cheque con ese número", "Error");
        return;
      }
      if (!this.newRow.payment_date) {
        this.$toast.error("Debe completar la fecha de pago", "Error");
        return;
      }
      if (!this.newRow.amount || parseFloat(this.newRow.amount) <= 0) {
        this.$toast.error("El importe debe ser mayor a 0", "Error");
        return;
      }

      this.cheques.push({
        number: this.newRow.number,
        payment_date: this.newRow.payment_date,
        amount: this.newRow.amount,
        observations: this.newRow.observations,
      });

      this.newRow = {
        number: this.nextNumber(this.newRow.number),
        payment_date: this.newRow.payment_date,
        amount: this.newRow.amount,
        observations: null,
      };
    },
    removeCheque(item) {
      const index = this.cheques.indexOf(item);
      if (index > -1) this.cheques.splice(index, 1);
    },
    confirm() {
      if (!this.validateHeader()) return;
      if (this.cheques.length === 0) {
        this.$toast.error("Debe agregar al menos un cheque", "Error");
        return;
      }

      const result = this.cheques.map((c) => ({
        id: 0,
        is_own: !this.thirdParty,
        emitter: this.thirdParty ? null : this.header.emitter,
        money_account: this.header.money_account,
        money_account_associated: this.thirdParty ? null : this.header.money_account,
        bank: this.header.bank,
        emitter_name: this.thirdParty ? String(this.header.emitter_name).trim() : null,
        emitter_receives: this.thirdParty ? this.header.money_account.emitter : null,
        state: null,
        number: c.number,
        amount: c.amount,
        emission_date: this.header.emission_date,
        payment_date: c.payment_date,
        observations: c.observations,
      }));

      this.$emit("callbackItems", result);
      this.close();
    },
    close() {
      this.$emit("updateDialog", false);
    },
  },
};
</script>
